riot.tag2('gb-collection-dropdown-item', '<a class="gb-collection" onclick="{selectDropdown}"> <span class="gb-collection__name">{option.label || option}</span> <gb-badge>{_scope.counts[option.value || option]}</gb-badge> </a>', '', '', function(opts) {
    this.selectDropdown = () => {
      if (typeof this.option === 'object') {
        this._scope.selectCustom(this.option);
      } else {
        this._scope.selectCustom({
          label: this.option,
          value: this.option
        });
      }
    };
});



/** WEBPACK FOOTER **
 ** ./src/tags/collections/gb-collection-dropdown-item.tag.html
 **/